import { getSortFilter } from '../UrlMapUtils';
export const resolveMetaDescription = (productLabel, sortOption) => {
  var _getSortFilter;
  const products = productLabel ? "Atlassian ".concat(productLabel) : 'Jira, Confluence, Bitbucket & other Atlassian products';
  const currentSort = (_getSortFilter = getSortFilter(sortOption)) === null || _getSortFilter === void 0 ? void 0 : _getSortFilter.label;
  const filterPrefix = currentSort ? "Find the ".concat(currentSort) : 'Find';
  return "".concat(filterPrefix, " apps, add-ons, plugins & integrations for ").concat(products, ". Free 30-day trial for all apps.");
};